export var OfficeProductType;
(function (OfficeProductType) {
    OfficeProductType["THERAME"] = "THERAME";
    OfficeProductType["LOCAL_OFFICE"] = "LOCAL_OFFICE";
})(OfficeProductType || (OfficeProductType = {}));
//# sourceMappingURL=office-product-type.enum.js.map